export default __webpack_public_path__ + "static/media/two.510fdfb5.glb";